import React, { FunctionComponent, ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { useMedia } from 'react-media-match';
import { useProduct } from '../ProductContext';

const SeoImageLinkWrapper = styled.div<{ mobile: boolean }>`
  font-size: 0.75rem;
  margin: ${({ mobile }) => (mobile ? '1.5rem 1.625rem;' : '1rem 0.625rem;')};
`;

/**
 * This is the seo image link component. It renders a link to the main product image for SEO purposes.
 */
export const SeoImageLink: FunctionComponent = (): ReactElement => {
  const isMobile = useMedia({ desktop: false, mobile: true, tablet: false });
  const { product } = useProduct();

  if (!product) {
    return null;
  }
  const [, imgExt] = product.images[0].slice(-5)?.split('.');
  const imageExtension =
    typeof imgExt !== 'undefined' && imgExt.match(/^(\w){3,4}$/g) !== null ? `.${imgExt}` : '.jpg';

  return (
    <SeoImageLinkWrapper data-testid="seo-image-link" mobile={isMobile}>
      <FormattedMessage id="seo-image-link.label" defaultMessage="Bildquelle:" />
      <span>&#160;</span>
      <a href={`${product.images[0]}/${product.slug}${imageExtension}`} title={product.name}>
        {product.name}
      </a>
    </SeoImageLinkWrapper>
  );
};

export default SeoImageLink;
